import styled from 'styled-components';
import { key } from 'styled-theme';

export const DashboardContainer = styled.main`
  font-family: ${key('fonts.primary', 'JetBrains Mono Regular')};
`;

export const Header = styled.header`
  background: linear-gradient(135deg, #94c5a0 0%, #5ba6ce 100%);
  padding: 1rem 2rem;
  color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const Logo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.25rem;
  font-weight: 600;
`;

export const LogoIcon = styled.div`
  width: 40px;
  height: 24px;
  background: linear-gradient(45deg, #94c5a0, #5ba6ce, #4a90e2);
  border-radius: 4px;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #5ba6ce, #4a90e2);
    border-radius: 0 0 4px 4px;
  }
`;

export const ContentContainer = styled.div`
  margin: auto;
  margin-bottom: 24px;
`;

export const Title = styled.h1`
  font-size: 1.125rem;
  font-weight: 600;
  color: #1a202c;
  margin-bottom: 1rem;
  letter-spacing: -0.025em;
`;

export const MetricsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
`;

export const MetricCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 1.5rem;

  border: 1px solid #e2e8f0;
  transition: all 0.2s ease-in-out;
  position: relative;

  &:hover {
    box-shadow:
      0 4px 6px rgba(0, 0, 0, 0.07),
      0 2px 4px rgba(0, 0, 0, 0.06);
    transform: translateY(-1px);
  }

  &:focus-within {
    outline: 2px solid #4299e1;
    outline-offset: 2px;
  }
`;

export const MetricValue = styled.div`
  font-size: 2.5rem;
  font-weight: 700;
  color: #1a202c;
  line-height: 1;
  margin-bottom: 0.5rem;
`;

export const MetricLabel = styled.div`
  font-size: 0.875rem;
  color: #718096;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export const MapIcon = styled.div`
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #94c5a0, #5ba6ce);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;

  &::before {
    content: '🗺️';
  }
`;

export const PoweredBy = styled.div`
  position: absolute;
  bottom: 10px;
  right: 15px;
  background: rgba(255, 255, 255, 0.9);
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.75rem;
  color: #4a5568;
  border: 1px solid #e2e8f0;
`;

export const SkipLink = styled.a`
  position: absolute;
  top: -40px;
  left: 6px;
  background: #000;
  color: #fff;
  padding: 8px;
  text-decoration: none;
  border-radius: 4px;
  z-index: 1000;

  &:focus {
    top: 6px;
  }
`;
